import { OilFieldDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadOilField = createAction('[OilField] Load OilField');

export const loadOilFieldSuccess = createAction(
  '[OilField] Load OilField Success',
  props<{ oilField: OilFieldDto[] }>()
);

export const loadOilFieldFailure = createAction(
  '[OilField] Load OilField Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addOilField = createAction(
  '[OilField] Add OilField',
  props<{ newOilField: OilFieldDto[] }>()
);

export const addOilFieldSuccess = createAction(
  '[OilField] Add OilField Success',
  props<{ newOilField: OilFieldDto[] }>()
);

export const addOilFieldFailure = createAction(
  '[OilField] Add OilField Failure',
  props<{ error: any }>()
);

/**
 * Update OilField Collection Actions
 */
export const updateOilField = createAction(
  '[OilField] Update OilField',
  props<{ updateOilField: OilFieldDto[] }>()
);

export const updateOilFieldSuccess = createAction(
  '[OilField] Update OilField Success',
  props<{ updateOilField: OilFieldDto[] }>()
);

export const updateOilFieldFailure = createAction(
  '[OilField] Update OilField Failure',
  props<{ error: any }>()
);

/**
 * Remove OilField Collection Actions
 */
export const removeOilField = createAction(
  '[OilField] Remove OilField',
  props<{ ids: string[] }>()
);

export const removeOilFieldSuccess = createAction(
  '[OilField] Remove OilField Success',
  props<{ ids: string[] }>()
);

export const removeOilFieldFailure = createAction(
  '[OilField] Remove OilField Failure',
  props<{ error: any }>()
);
